import React, { useEffect, useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import endpoints from '../constants/endpoints';

const icons = {
  linkedin: {
    viewBox: '0 0 24 24',
    path: 'M6.94 8.5H3.56V19.5h3.38V8.5zM5.25 3A1.97 1.97 0 0 0 3.28 4.97c0 1.08.88 1.97 1.97 1.97a1.98 1.98 0 1 0 0-3.94zM20.44 12.62c0-3.31-1.77-4.85-4.12-4.85-1.9 0-2.75 1.04-3.22 1.78V8.5H9.72c.04.69 0 11 0 11h3.38v-6.14c0-.33.02-.66.12-.9.26-.66.84-1.35 1.82-1.35 1.28 0 1.8.98 1.8 2.42v5.97h3.38v-6.88z',
  },
  github: {
    viewBox: '0 0 24 24',
    path: 'M12 .5C5.65.5.5 5.66.5 12.03c0 5.1 3.29 9.43 7.86 10.96.57.11.78-.25.78-.56 0-.27-.01-1-.02-1.97-3.2.7-3.88-1.54-3.88-1.54-.53-1.34-1.28-1.7-1.28-1.7-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.04 1.77 2.72 1.26 3.38.96.11-.75.4-1.26.73-1.55-2.55-.29-5.23-1.27-5.23-5.67 0-1.26.45-2.3 1.18-3.1-.12-.29-.51-1.45.11-3.02 0 0 .97-.31 3.17 1.18a10.9 10.9 0 0 1 5.76 0c2.2-1.49 3.17-1.18 3.17-1.18.62 1.57.23 2.73.11 3.02.74.8 1.18 1.84 1.18 3.1 0 4.41-2.69 5.38-5.25 5.66.41.35.78 1.06.78 2.15 0 1.55-.02 2.8-.02 3.18 0 .31.2.68.79.56A11.55 11.55 0 0 0 23.5 12.03C23.5 5.66 18.35.5 12 .5z',
  },
  email: {
    viewBox: '0 0 24 24',
    path: 'M2 5.5A2.5 2.5 0 0 1 4.5 3h15A2.5 2.5 0 0 1 22 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 18.5v-13zm2.2-.5 7.8 6.15L19.8 5H4.2zm15.8 1.56-6.95 5.48a1.7 1.7 0 0 1-2.1 0L4 6.56V18.5c0 .28.22.5.5.5h15a.5.5 0 0 0 .5-.5V6.56z',
  },
};

const styles = {
  buttonStyle: {
    '--social-accent': undefined,
  },
};

function Social() {
  const theme = useContext(ThemeContext);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.social, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  return (
    <div className="social">
      {data ? data.social.map((social) => (
        <a
          key={social.network}
          className="social__link"
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.network}
          style={{
            ...styles.buttonStyle,
            '--social-accent': theme.accentColor,
          }}
        >
          <svg viewBox={icons[social.network]?.viewBox} aria-hidden="true">
            <path d={icons[social.network]?.path} />
          </svg>
        </a>
      )) : null}
    </div>
  );
}

export default Social;
